export default __webpack_public_path__ + "static/media/loading.41c00dc1.svg";